import React from 'react';
import { ChatDashboardTab, ChatDashboardTabConfig } from '../../types';

interface TabSiderProps {
  tabs: ChatDashboardTabConfig[];
  activeTab: ChatDashboardTab;
  onTabChange: (tab: ChatDashboardTab) => void;
}

const TabSider: React.FC<TabSiderProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <aside className="w-64 border-r border-gray-200 bg-white">
      <div className="px-6 py-4 border-b border-gray-100">
        <h2 className="text-lg font-semibold text-gray-900">Chat Dashboard</h2>
        <p className="text-sm text-gray-500">Navigate between insights</p>
      </div>
      <nav className="p-4 space-y-2">
        {tabs.map((tab) => {
          const isActive = tab.key === activeTab;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onTabChange(tab.key)}
              className={`w-full text-left px-4 py-2 rounded-lg font-medium transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700 border border-blue-100'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default TabSider;
